<template>
	<div class="flex-row flex-center spa-cont padding">
		<loading :active="!errMsg" :is-full-page="true" :background-color="$colorBackground" :color="$colorPrimary"></loading>
		<div>
			<p style="font-size: 17px;">{{errMsg}}</p>
		</div>
	</div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { fs_login } from "@/firebaseConfig.js";

export default {
	name: 'App',
	components: {
		Loading,
	},

	data() {
		return {
			errMsg: '',
		}
	},

	async created() {
		console.log(`The info is ${this.$dataref}`)
		const res = await fs_login(this.$dataref);

		if (res.error) { this.errMsg = res.msg; }

		if ('credential' in res && window.ipcRenderer) {
			window.ipcRenderer.invoke('send-cred', res);
		}
	},
}
</script>
<style>
p {
	font-size: 2rem;
}
</style>